export var firebaseConfig = {
    apiKey: "AIzaSyA090obbubnDbwl_OeeCoabHPWAAqQ7RRc",
    authDomain: "project-logcat.firebaseapp.com",
    databaseURL: "https://project-logcat.firebaseio.com",
    projectId: "project-logcat",
    storageBucket: "project-logcat.appspot.com",
    messagingSenderId: "102839130340",
    appId: "1:102839130340:web:bd374099965970b87034f1",
    measurementId: "G-62F27V0N4F"
};
export var firebaseConfigTest = {
    apiKey: "AIzaSyDyGw1K2ntdzOPv_yz0zBRoLWGp0b_y2Po",
    authDomain: "project-logcat.firebaseapp.com",
    databaseURL: "https://project-logcat.firebaseio.com",
    projectId: "project-logcat",
    storageBucket: "project-logcat.appspot.com",
    messagingSenderId: "102839130340",
    appId: "1:102839130340:web:bd374099965970b87034f1",
    measurementId: "G-62F27V0N4F"
};
//# sourceMappingURL=configs.js.map